import React from 'react';
import { FieldDiamond } from './FieldDiamond';
import { volumes } from '../data/volumes';
type PackShotProps = {
  className?: string;
  tone?: 'dark' | 'light';
};

/**
 * Las 6 portadas del pack dibujadas en código con la identidad DPS-33.
 * Se usa mientras no esté cargado el mockup real (data/images.ts → hero).
 */
export function PackShot({
  className = '',
  tone = 'dark'
}: PackShotProps) {
  const frame = tone === 'dark' ? 'border-navy-line bg-navy-deep/60' : 'border-ice-dark bg-ice';
  return <div role="img" aria-label="The six Softball Season-Ready volumes" className={`rounded-2xl border p-4 sm:p-6 shadow-card ${frame} ${className}`} data-id="element-193" data-mp="12xhdwqw3w6a3">
      <ul className="grid grid-cols-3 gap-2.5 sm:gap-3.5" data-id="element-194" data-mp="1covhb9r6hq8i">
        {volumes.map(vol => <li key={vol.number} className="relative aspect-[3/4] overflow-hidden rounded-lg bg-navy shadow-card ring-1 ring-white/10" data-id="element-195" data-mp="1hnosuwmwn761">
            <span className={`absolute inset-x-0 top-0 h-1.5 ${vol.accent}`} data-id="element-196" data-mp="1mkf7dfj29upc" />
            <FieldDiamond className="pointer-events-none absolute -bottom-6 -right-6 h-24 w-24 text-white/10 sm:h-28 sm:w-28" data-id="element-197" data-mp="2gerwtw9r5pgs" />
            <span className="pointer-events-none absolute bottom-3 left-3 h-3.5 w-3.5 rounded-full bg-gold shadow-[0_0_0_3px_rgba(230,230,0,0.18)] sm:h-4 sm:w-4" data-id="element-198" data-mp="2bggndmnddgz3" />
            <div className="relative flex h-full flex-col p-2.5 pt-3.5 sm:p-3.5 sm:pt-5" data-id="element-199" data-mp="22f0ejjc7dmwz">
              <span className="font-display text-[9px] tracking-[1.5px] text-gold sm:text-[11px]" data-id="element-200" data-mp="2z2dhhjp0wfzz">
                Vol. {vol.number}
              </span>
              <span className="mt-1 font-display text-[13px] leading-[1.02] text-white sm:text-lg" data-id="element-201" data-mp="2pdn6jic09hou">
                {vol.title}
              </span>
              <span className="mt-auto self-end text-[8px] font-bold uppercase tracking-widest text-white/45 sm:text-[9px]" data-id="element-202" data-mp="2lbs6si9q3cd6">
                Season-Ready
              </span>
            </div>
          </li>)}
      </ul>
      <p className={`chalk-note mt-3.5 text-center text-xl sm:text-2xl ${tone === 'dark' ? 'text-gold' : 'text-clay-deep'}`} data-id="element-203" data-mp="3d1d5cp4poqv3">
        6 volumes · 5 bonuses · 300 pages
      </p>
    </div>;
}